import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

export const TermsPage: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900 font-sans antialiased">
      {/* Navbar */}
      <header className="sticky top-0 z-50 border-b border-slate-200 bg-white/80 backdrop-blur-xl">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 text-slate-600 hover:text-blue-600 transition-colors font-medium text-sm">
            <ArrowLeftIcon className="w-4 h-4" />
            <span>Volver a la página principal</span>
          </Link>
          <span className="font-bold text-slate-900">Términos y Condiciones</span>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="rounded-2xl border border-slate-200 bg-white p-8 sm:p-12 shadow-sm prose prose-slate max-w-none">
          <div className="border-b border-slate-100 pb-6 mb-8">
            <p className="text-xs font-bold text-blue-600 uppercase tracking-widest">Legal</p>
            <h1 className="text-3xl font-extrabold text-slate-900 mt-1">Términos y Condiciones de Uso</h1>
            <p className="text-xs text-slate-400 mt-2">Última actualización: Mayo de {currentYear}</p>
          </div>

          <section className="space-y-6 text-slate-600 leading-relaxed text-sm sm:text-base">
            <div>
              <h3 className="text-lg font-bold text-slate-900 mb-2">1. Objeto y Alcance</h3>
              <p>
                Los presentes Términos y Condiciones regulan el acceso y uso de la plataforma de software como servicio (SaaS) <strong>DH Assembly</strong>, desarrollada y operada por <strong>DHING ®</strong>. La plataforma está destinada a facilitar la gestión, cálculo de quórum, votaciones electrónicas y generación de actas para asambleas de copropietarios bajo el régimen de Propiedad Horizontal en Colombia (Ley 675 de 2001).
              </p>
            </div>

            <div>
              <h3 className="text-lg font-bold text-slate-900 mb-2">2. Cuentas de Usuario y Credenciales</h3>
              <p>
                El acceso a la plataforma se realiza mediante cuentas personales creadas a partir de la información provista oficialmente por la administración de cada conjunto residencial. El usuario es el único responsable de mantener la confidencialidad de sus credenciales de acceso y de cualquier actividad que ocurra bajo su cuenta. Está estrictamente prohibido el uso compartido de cuentas para preservar la validez jurídica del quórum y los votos.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-bold text-slate-900 mb-2">3. Legalidad y Ponderación del Voto</h3>
              <p>
                El cálculo del quórum y la ponderación de las votaciones electrónicas se realizan de forma automatizada e inmutable de acuerdo con los coeficientes de copropiedad registrados en el sistema por el administrador. <strong>DHING ®</strong> provee la herramienta tecnológica y no asume responsabilidad por la exactitud de los datos e información cargados inicialmente por la administración del conjunto.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-bold text-slate-900 mb-2">4. Delegación de Representación (Poderes)</h3>
              <p>
                La plataforma permite la delegación de voto conforme a la ley. Para garantizar la seguridad del evento, un propietario únicamente puede otorgar poder de representación a otro propietario debidamente registrado en el mismo conjunto residencial. Las delegaciones son registradas de forma trazable en el acta final.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-bold text-slate-900 mb-2">5. Disponibilidad del Servicio</h3>
              <p>
                <strong>DHING ®</strong> se compromete a realizar sus mejores esfuerzos técnicos para asegurar la disponibilidad continua de la plataforma durante las asambleas programadas. No obstante, no se hace responsable por interrupciones derivadas de fallas en la conexión a internet del usuario, cortes de energía eléctrica o eventos de fuerza mayor.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-bold text-slate-900 mb-2">6. Propiedad Intelectual</h3>
              <p>
                Todo el código fuente, diseño visual, logotipos, flujos operativos y arquitectura de la plataforma <strong>DH Assembly</strong> son propiedad exclusiva de <strong>DHING ®</strong> y están protegidos por las leyes de propiedad intelectual y derechos de autor vigentes.
              </p>
            </div>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-slate-200 mt-12 py-8 text-center text-xs text-slate-400 bg-white">
        <p>&copy; 2019-{currentYear} <strong>DHING ®</strong>. Todos los derechos reservados.</p>
      </footer>
    </div>
  );
};
export default TermsPage;
